import { __module as e } from "../../../_virtual/isRFC3339.js";
import { a as c } from "./util/assertString.js";
Object.defineProperty(o = e.exports, "__esModule", {
  value: !0
}), o.default = function (e) {
  return (0, t.default)(e), x.test(e);
}, t = c && c.__esModule ? c : {
  default: c
}, r = /([01][0-9]|2[0-3])/, s = /[0-5][0-9]/, a = new RegExp("[-+]".concat(r.source, ":").concat(s.source)), u = new RegExp("([zZ]|".concat(a.source, ")")), n = new RegExp("".concat(r.source, ":").concat(s.source, ":").concat(/([0-5][0-9]|60)/.source).concat(/(\.[0-9]+)?/.source)), p = new RegExp("".concat(/[0-9]{4}/.source, "-").concat(/(0[1-9]|1[0-2])/.source, "-").concat(/([12]\d|0[1-9]|3[01])/.source)), l = new RegExp("".concat(n.source).concat(u.source)), x = new RegExp("^".concat(p.source, "[ tT]").concat(l.source, "$")), e.exports = o.default, e.exports.default = o.default;
var o,
  t,
  r,
  s,
  a,
  u,
  n,
  p,
  l,
  x,
  d = e.exports;
export { d as i };